import React from "react";
import QRCode from "react-qr-code";
import BlueLoader from "../loader/BlueLoader";

export default function CarQr({
  setIsCarQrOpen,
  isLoadingQrCode,
  setIsLoadingQrCode,
  carQrToken = "",
  setCarQrToken,
}) {
  return (
    <div
      className="absolute w-full h-screen backdrop-blur-sm flex flex-col items-center justify-center z-[1000] px-[8vw] "
      id="bg"
      onClick={(e) => {
        if (e.target.id === "bg") setIsCarQrOpen(false);
      }}
    >
      <div className="w-full flex flex-col items-center justify-center  ">
        <div className="w-full flex items-center justify-center bg-color-primary-D font-font_primary_A text-[#153038] rounded-t-[1vw]">
          <span className="py-[2vw]">اسکن کد</span>
        </div>
        <div className="w-full flex flex-col items-center justify-center font-font_primary_A text-[#FFF] bg-[#001D26] gap-y-[3vw] p-[2vw] py-[4vw]  rounded-[1.5vw]">
          <div className="w-full flex items-center justify-center text-center px-[3vw]">
            <p className="text-color-primary-C3 text-[3.2vw] ">
              جهت دسترسی موقت اتوسرویس به اطلاعات سرویس خودرو شما، تصویر کد زیر
              را بایستی توسط تعمیرگاه اسکن گردد
            </p>
          </div>
          <div className="w-full relative flex items-center justify-center">
            <QRCode
              value={carQrToken ? carQrToken : ""}
              size={32}
              style={{
                height: "50vw",
                maxWidth: "50vw",
                width: "50vw",
                top: "0px",
                zIndex: "10",
                border: "2vw #FFF solid",
                borderRadius: "2vw",
              }}
            />
            {isLoadingQrCode && (
              <div className="absolute w-full h-full backdrop-blur-sm flex items-center justify-center z-[20]">
                <BlueLoader position="" width={15} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
